export const app = import.meta.env.VITE_PACKAGE_NAME;
export const ORIGIN_URL = import.meta.env.VITE_ORIGIN_URL;
export const COMPANY_ID = import.meta.env.VITE_COMPANY_ID;

export const KAKAOTALK_URL = 'https://pf.kakao.com/_ndFtC/chat';

export const CAR_SHEET_COMPANY = {
  name: '꾸러기유모차',
  url: 'https://www.gureogi.com',
  tel: '064-745-9996',
};
